import MetaTags from "react-meta-tags";

// components
import { AboutUsStory } from "components/AboutUS/AboutUsStory";
import AboutUsIntro from "components/AboutUS/Intro";
import AbousUsJoinUs from "components/AboutUS/JoinUs";
import AboutUsStats from "components/AboutUS/Stats";
import Team from "components/AboutUS/Team";
import Timeline from "components/AboutUS/Timeline";
import Footer from "components/Footer";
import FeedbackContainer from "components/Home/HomeFeedback/FeedbackContainer";
import HomeHighlighted from "components/Home/HomeHighlighted";
import { NavbarAndSidebar } from "components/NavbarAndSidebar";
// import AboutUsFeatured from "components/AboutUS/Featured";
// import AboutUsInvestors from "components/AboutUS/Investors";
// import AboutUsValues from "components/AboutUS/Values/AboutUsValues";
// import { FloatingButton } from "components/FloatingButton";

// styles
import "./style.scss";

const AboutUsPage = () => {
	return (
		<div className="about__wrapper">
			<MetaTags>
				<title>About Us | SaffronStays</title>
			</MetaTags>
			<NavbarAndSidebar />

			<AboutUsStory />
			<AboutUsIntro />
			<AboutUsStats />
			<Timeline />
			{/* <AboutUsValues /> */}
			<Team />
			{/* <AboutUsFeatured /> */}
			<FeedbackContainer />
			<HomeHighlighted />
			{/* <AboutUsInvestors /> */}
			<AbousUsJoinUs />
			{/* <FloatingButton bottom={"20px"} right={"20px"} /> */}
			<Footer />
		</div>
	);
};

export default AboutUsPage;
